import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Button } from "../skapa/button.js";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType) => {
    if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.log("inside login button4");
        console.log(e);
      });
    }
  };
  return (
    <div class="logininbtn">
      <Button
        class="btn btn--emphasised"
        type="primary"
        variant="secondary"
        onClick={() => handleLogin("redirect")}
        className="ml-auto"
        drop="start"
        title="Sign In"
      >
        LOGIN
      </Button>
    </div>
  );
};